import { Link, NavLink } from "react-router-dom";
import { PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "../../components/assets/logo.png";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "Contact", to: "/contact" },
];

export default function SiteHeader({ company }) {
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur-sm">
      <div className="bg-slate-900 py-2 text-xs text-white">
        <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <p data-testid="header-company-name" className="font-medium tracking-wide">
            {company.name}
          </p>
          <a
            href={`tel:${company.phone.replace(/\s+/g, "")}`}
            data-testid="header-phone-link"
            className="inline-flex items-center gap-2 font-semibold text-orange-300 transition-colors hover:text-orange-200"
          >
            <PhoneCall className="h-3 w-3" />
            {company.phone}
          </a>
        </div>
      </div>

      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
<img
  src={logo}
  alt="HEXA INFOTECH logo"
  data-testid="header-logo-image"
  className="h-12 w-10 object-contain"
/>
          <div>
            <p data-testid="header-brand-title" className="font-heading text-xl font-bold text-slate-900">
              HEXA INFOTECH
            </p>
            <p data-testid="header-brand-subtitle" className="text-xs text-slate-500">
              Networking Accessories & Telecom Supplies
            </p>
          </div>
        </Link>

        <div className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`header-nav-${item.label.toLowerCase()}-link`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors ${
                  isActive ? "text-orange-600" : "text-slate-700 hover:text-slate-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <Button
          asChild
          className="rounded-sm bg-orange-500 text-white hover:bg-orange-600"
          data-testid="header-catalog-button"
        >
          <Link to="/products">View Catalog</Link>
        </Button>
      </nav>
    </header>
  );
}
